module.exports = __webpack_public_path__ + "static/media/logout.fc45756b.svg";